import { Header } from '@components/Header';
import { Helmet } from 'react-helmet-async';
import { Section } from './components/Section';
import { ShowcaseHint } from './components/ShowcaseHint';
import {
  AudioPlayerDemo,
  CardsDemo,
  EntityIconDemo,
  FilesDemo,
  OrganizationCardsDemo,
  PaginationDemo,
  SkeletonDemo,
  SpinnersDemo,
  TagsDemo,
  TeamCardsDemo,
} from './sections/demos/AdditionalDemos';
import { ButtonsDemo } from './sections/demos/ButtonsDemo';
import { CircularProgressDemo } from './sections/demos/CircularProgressDemo';
import { DisclosureSectionDemo } from './sections/demos/DisclosureSectionDemo';
import { EnvironmentIndicatorsDemo } from './sections/demos/EnvironmentIndicatorsDemo';
import { FormsDemo } from './sections/demos/FormsDemo';
import {
  BlockDemo,
  DividerDemo,
  ErrorMessageDemo,
  GenericPageErrorDemo,
  JobStatusTextDemo,
  LogoDemo,
  PopoverDemo,
  TooltipDemo,
} from './sections/demos/PhaseADemos';
import { TableDemo } from './sections/demos/TableDemo';

const groupHeadingClassName = 'mb-4 text-lg font-semibold text-[var(--color-text)]';

export const ComponentShowcasePage = () => (
  <>
    <Helmet>
      <title>Component Showcase - AutoScript Admin</title>
    </Helmet>
    <Header title="Component showcase" />
    <div className="mx-auto max-w-5xl px-6 py-6">
      <ShowcaseHint />

      <div className="mb-10">
        <h1 className={groupHeadingClassName}>Indicators</h1>
        <Section title="AppVersionTag / EnvironmentRibbon">
          <EnvironmentIndicatorsDemo />
        </Section>
      </div>

      <div className="mb-10">
        <h1 className={groupHeadingClassName}>Spinners</h1>
        <Section title="CircularProgress">
          <CircularProgressDemo />
        </Section>
        <Section title="Spinner / LinearProgressLoader">
          <SpinnersDemo />
        </Section>
        <Section title="Skeleton">
          <SkeletonDemo />
        </Section>
      </div>

      <div className="mb-10">
        <h1 className={groupHeadingClassName}>Feedback</h1>
        <Section title="JobStatusText">
          <JobStatusTextDemo />
        </Section>
        <Section title="ErrorMessage">
          <ErrorMessageDemo />
        </Section>
        <Section title="GenericPageError">
          <GenericPageErrorDemo />
        </Section>
      </div>

      <div className="mb-10">
        <h1 className={groupHeadingClassName}>Layout</h1>
        <Section title="DisclosureSection">
          <DisclosureSectionDemo />
        </Section>
        <Section title="Divider">
          <DividerDemo />
        </Section>
        <Section title="Block">
          <BlockDemo />
        </Section>
        <Section title="Popover">
          <PopoverDemo />
        </Section>
        <Section title="Tooltip">
          <TooltipDemo />
        </Section>
      </div>

      <div className="mb-10">
        <h1 className={groupHeadingClassName}>Forms</h1>
        <Section title="Form elements">
          <FormsDemo />
        </Section>
      </div>

      <div className="mb-10">
        <h1 className={groupHeadingClassName}>Buttons</h1>
        <Section title="Button variations">
          <ButtonsDemo />
        </Section>
        <Section title="EntityIcon">
          <EntityIconDemo />
        </Section>
      </div>

      <div className="mb-10">
        <h1 className={groupHeadingClassName}>Tags</h1>
        <Section title="Tag variations">
          <TagsDemo />
        </Section>
      </div>

      <div className="mb-10">
        <h1 className={groupHeadingClassName}>Table</h1>
        <Section title="Table">
          <TableDemo />
        </Section>
        <Section title="PagePagination">
          <PaginationDemo />
        </Section>
      </div>

      <div className="mb-10">
        <h1 className={groupHeadingClassName}>Files</h1>
        <Section title="DropZone">
          <FilesDemo />
        </Section>
        <Section title="AudioPlayer">
          <AudioPlayerDemo />
        </Section>
      </div>

      <div className="mb-10">
        <h1 className={groupHeadingClassName}>Feature</h1>
        <Section title="UniversalCard / UniversalNoPictureCard">
          <CardsDemo />
        </Section>
        <Section title="TeamCards">
          <TeamCardsDemo />
        </Section>
        <Section title="OrganizationCards">
          <OrganizationCardsDemo />
        </Section>
        <Section title="VsLogo">
          <LogoDemo />
        </Section>
      </div>
    </div>
  </>
);
